import { render, staticRenderFns } from "./basic-package.vue?vue&type=template&id=286a3ed0&scoped=true&"
import script from "./basic-package.vue?vue&type=script&lang=js&"
export * from "./basic-package.vue?vue&type=script&lang=js&"
import style0 from "./basic-package.vue?vue&type=style&index=0&id=286a3ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a3ed0",
  null
  
)

export default component.exports